var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9de6cf2dd14cace4de952f2b3c580de4d7f431f6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["fontvisual"]={id:"9de6cf2dd14cace4de952f2b3c580de4d7f431f6"};
      